export default __webpack_public_path__ + "sill_plate.png";